module.exports = __webpack_public_path__ + "img/arrow-left.293dbf5e.svg";